import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { AnalisesSpggProjeto } from '../../models/analises-spgg-projeto.model';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { AnalisesSpggProjetoService } from '../../services/analises-spgg-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';

@Component({
  selector: 'app-detalhe-projeto-analises-spgg-edit',
  templateUrl: './detalhe-projeto-analises-spgg-edit.component.html',
  styleUrls: ['./detalhe-projeto-analises-spgg-edit.component.scss']
})
export class DetalheProjetoAnalisesSpggEditComponent extends BaseFormComponent<AnalisesSpggProjeto> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  actionLabel: string = 'Novo';
  statusList: any[] = [];
  situacaoList: any[] = [];
  showSituacao: boolean;
  audit: AtualizacoesAudit;

  constructor(
    private myService: AnalisesSpggProjetoService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loading();
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initForm();
    });

    this.myService.getOptions(this.idProjeto).subscribe((data) => {
      this.statusList = data['statusList'];
      this.situacaoList = data['situacaoList'];

      let status_id = data['last']['analysis_stat_id'];
      this.form.get('analysis_stat_id').setValue(status_id);

      this.showSituacao = status_id == 2; // Mostrar div quando '2' for selecionada
      if (!this.showSituacao) {
        this.form.get('analysis_sub_stat_id').setValue('');
      } else {
        let situacao_id = data['last']['analysis_sub_stat_id'];
        this.form.get('analysis_sub_stat_id').setValue(situacao_id);
      }
      this.loaded();
    });
  }

  initForm() {
    this.form = this.fb.group({
      id: [''],
      analysis_stat_id: [null, Validators.required],
      analysis_sub_stat_id: [null],
      description: ['', [Validators.required, Validators.maxLength(1000)]],
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.audit = {
        analysis_id: this.entity.id
      };

      this.showSituacao = this.entity.analysis_stat_id == 2;
      if (!this.showSituacao) {
        this.form.get('analysis_sub_stat_id').setValue('');
      }
    }
  }

  voltar() {
    this.navigation.back(['projetos', 'projeto', this.idProjeto, 'analises']);
  }

  getDataCreate(): AnalisesSpggProjeto {
    let data: AnalisesSpggProjeto;
    data = Object.assign({}, data, this.form.value);

    data.pf_id = this.idProjeto;
    return data;
  }

  onStatusChange() {
    const selectedValue = this.form.get('analysis_stat_id').value;
    this.showSituacao = selectedValue == 2; // Mostrar div quando '2' for selecionada

    if (!this.showSituacao) {
      this.form.get('analysis_sub_stat_id').setValue(null);
    }
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: AnalisesSpggProjeto) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error.error)
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: AnalisesSpggProjeto) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'analises', 'spgg', res.id]);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error.error)
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

}
